import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";
import { AppDispatch } from "../../../redux/store";
import { acceptAdminInvitation } from "../actions/acceptAdminInvitation";

export const useAcceptInvitationMutation = (uid: string) => {
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationKey: ["acceptAdminInvitation", uid],
    mutationFn: () => acceptAdminInvitation(uid),
    onSuccess: async (data) => {
      const { token, refresh_token } = data || {};

      if (token) localStorage.setItem("token", token);
      if (refresh_token?.token) {
        sessionStorage.setItem("refresh_token", refresh_token.token);
      }

      await dispatch(fetchBenefits());
    },
  });
};
